import React from 'react';
import Animator from './Animator';

function getAnglePoint(startAngle, endAngle, radius, x, y) {
    let x1, y1, x2, y2;
    x1 = x + radius * Math.cos((Math.PI * startAngle) / 180);
    y1 = y + radius * Math.sin((Math.PI * startAngle) / 180);
    x2 = x + radius * Math.cos((Math.PI * endAngle) / 180);
    y2 = y + radius * Math.sin((Math.PI * endAngle) / 180);
    return { x1, y1, x2, y2 };
}

function resolveThreshold(threshold, thresholds) {
    let value = null;
    if (thresholds) {
        for (let i = thresholds.length - 1; i >= 0; i--) {
            if (threshold <= thresholds[i][1]) {
                value = thresholds[i][0];
            }
        }
    }
    return value;
}

class Slice extends React.Component {
    constructor(props) {
        super(props);
        this.animate = this.animate.bind(this);
        this.animator = new Animator();
    }

    componentWillReceiveProps(nextProps) {
        this.animator.play({
            duration: this.props.duration,
            intervals: {
                angle: [this.props.angle, nextProps.angle],
                startAngle: [this.props.startAngle, nextProps.startAngle]
            },
            easing: Animator.easeOutExpo,
            onStep: this.animate
        });
    }

    componentDidMount() {
        this.animator.play({
            duration: this.props.duration,
            intervals: {
                angle: [0, this.props.angle]
            },
            easing: Animator.easeInOutExpo,
            onStep: this.animate
        });
    }

    componentWillUnmount() {
        this.animator.stop();
    }

    animate(intervals) {
        const p = this.props,
            path = [];
        const startAngle = intervals.startAngle || p.startAngle;
        const diffAngle = intervals.angle;

        if (diffAngle !== 360) {
            const a = getAnglePoint(startAngle, startAngle + diffAngle, p.radius, p.radius, p.radius);
            const b = getAnglePoint(startAngle, startAngle + diffAngle, p.radius - p.hole, p.radius, p.radius);
            path.push('M' + a.x1 + ',' + a.y1);
            path.push('A' + p.radius + ',' + p.radius + ' 0 ' + (diffAngle > 180 ? 1 : 0) + ',1 ' + a.x2 + ',' + a.y2);
            path.push('L' + b.x2 + ',' + b.y2);
            path.push(
                'A' +
                    (p.radius - p.hole) +
                    ',' +
                    (p.radius - p.hole) +
                    ' 0 ' +
                    (diffAngle > 180 ? 1 : 0) +
                    ',0 ' +
                    b.x1 +
                    ',' +
                    b.y1
            );
            path.push('Z');
        } else {
            // lebo 360 arc sa neda nakreslit cez 1 arc
            path.push('M' + p.radius + ',' + 0);
            path.push('A' + p.radius + ',' + p.radius + ' 0 1,0 ' + p.radius + ',' + 2 * p.radius);
            path.push('A' + p.radius + ',' + p.radius + ' 0 1,0 ' + p.radius + ',' + 0);
            path.push('Z');
            path.push('M' + p.radius + ',' + p.hole);
            path.push(
                'A' +
                    (p.radius - p.hole) +
                    ',' +
                    (p.radius - p.hole) +
                    ' 0 1,0 ' +
                    p.radius +
                    ',' +
                    (2 * p.radius - p.hole)
            );
            path.push('A' + (p.radius - p.hole) + ',' + (p.radius - p.hole) + ' 0 1,0 ' + p.radius + ',' + p.hole);
            path.push('Z');
        }
        this.slicePath.setAttribute('d', path.join(' '));

        let percent = Math.round(10 * (diffAngle / 3.6)) / 10;
        if (this.props.showLabel) {
            this.sliceText.textContent = percent + '%';
        }
        const clazz = resolveThreshold(percent, this.props.classThresholds);
        if (clazz) {
            this.slicePath.setAttribute('class', clazz);
        }
    }

    render() {
        const clazz = resolveThreshold(0, this.props.classThresholds);
        return (
            <g overflow="hidden">
                <path
                    d={''}
                    className={clazz}
                    fill={this.props.fill}
                    fillRule="evenodd"
                    ref={c => {
                        this.slicePath = c;
                    }}
                />
                {this.props.showLabel ? (
                    <text
                        x="35"
                        y="41"
                        textAnchor="middle"
                        ref={c => {
                            this.sliceText = c;
                        }}
                    />
                ) : null}
            </g>
        );
    }
}

const StrokeRing = ({ radius, hole }) => (
    <g overflow="hidden">
        <circle className="ring-path" cx={radius} cy={radius} fill="none" r={30} strokeWidth={hole - hole * 0.05} />
    </g>
);

export const Progress = ({ radius, fill, progress, hole, duration, classThresholds, fillPath, fillBg, showLabel }) => {
    let diameter = radius * 2;
    return (
        <svg width={diameter} height={diameter} viewBox={'0 0 ' + diameter + ' ' + diameter} version="1.1">
            <StrokeRing
                fill={fillPath || '#ffffff'}
                fillBg={fillBg || '#ffffff'}
                radius={radius}
                hole={radius - hole}
            />
            <Slice
                startAngle={270}
                angle={progress * 3.6}
                radius={radius}
                hole={radius - hole}
                showLabel={showLabel}
                duration={duration || 1500}
                fill={fill}
                classThresholds={classThresholds}
            />
        </svg>
    );
};
